import React, { useContext, useMemo, useState } from 'react';

import './StudioAuthoringPathwaysViewContent.css';
import { Link } from 'react-router-dom';
import {
  getRamdomCourseImg,
  getStudioURL,
  getTableSizes,
  getUserId,
} from '../../../hooks/helpers';
import TableSizeDropdown from '../../../components/TableSizeDropdown/TableSizeDropdown';
import {
  getUserName,
  IBLSpinLoader,
  AppDataContext,
} from '@acilearning/ibl-web-react-common';
import EmptyTableDataInfographic from '../../../components/EmptyTableDataInfographic/EmptyTableDataInfographic';
import { useStudioAuthoringPrograms } from '../../../hooks/useStudioAuthoringPrograms';
import AddPathway from '../../../components/AddPathway/AddPathway';
import usePathways from '../../../hooks/usePathways';
import PathwayDetailPopup from '../../../components/PathwayDetailPopup/PathwayDetailPopup';
import AssignContentToUser from '../../../components/AssignContentToUser/AssignContentToUser';
import {
  CONFIRM_TEXT,
  MESSAGE,
  CONTENT_TYPE,
  CANCEL_TEXT,
  POPUP_TYPE,
  WARNING,
} from '../../../components/DeletePopUp/constants';
import DeletePopup from '../../../components/DeletePopUp/DeletePopup';

const TABLE_SIZES = getTableSizes();

const StudioAuthoringPathwaysViewContent = () => {
  const { setNotification } = useContext(AppDataContext);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(TABLE_SIZES[0]);
  const [refresher, setRefresher] = useState(null);
  const { filteredPathways, loading } = usePathways({ search, refresher });
  const [addOrEditPathwayFocused, setAddOrEditPathwayFocused] = useState(false);
  const [focusedPathwayForDisplay, setFocusedPathwayForDisplay] =
    useState(null);
  const [focusedPathwayForEdit, setFocusedPathwayForEdit] = useState(null);
  const [assignContentPopupOpen, setAssignContentPopupOpen] = useState(false);
  const [showDeletePopUp, setShowDeletePopUp] = useState(false);
  const [selectedPathway, setSelectedPathway] = useState(null);
  const loggedInUserId = getUserId();

  const parseDurationToMinutes = (durationStr) => {
    if (!durationStr || durationStr.trim() === '') return 60;

    const lower = durationStr.trim().toLowerCase();
    let totalMinutes = 0;

    // Match hours
    const hourMatch = lower.match(/(\d+)\s*(h|hr|hrs|hour|hours)/);
    if (hourMatch) totalMinutes += parseInt(hourMatch[1], 10) * 60;

    // Match minutes
    const minMatch = lower.match(/(\d+)\s*(m|min|mins|minute|minutes)/);
    if (minMatch) totalMinutes += parseInt(minMatch[1], 10);

    // If just a number → treat as SECONDS now
    if (!hourMatch && !minMatch && !isNaN(Number(lower))) {
      const seconds = parseInt(lower, 10);
      totalMinutes += seconds / 60; // convert seconds to minutes
    }

    return totalMinutes;
  };

  // Always show both hours and minutes, zero-padded minutes if needed
  const formatMinutes = (mins) => {
    const totalMinutes = Math.floor(mins); // drop any fractional part
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    return `${hours}h ${minutes}m`; // always show hours and minutes
  };

  const totalMinutes = useMemo(() => {
    return filteredPathways.reduce((sum, course) => {
      const courseDuration =
        course?.duration ||
        course?.edx_data?.duration ||
        course?.data?.edx_data?.duration ||
        '';
      return sum + parseDurationToMinutes(courseDuration);
    }, 0);
  }, [filteredPathways]);

  const formattedDuration = formatMinutes(totalMinutes);

  const handleSetNotification = (success, msg) => {
    setNotification({
      msg: msg,
      success,
    });
  };

  const handleDeletePathway = async () => {
    const params = new URLSearchParams({
      pathway_id: selectedPathway?.pathway_id,
      user_id: selectedPathway?.user_id || getUserId(),
    }).toString();
    await fetch(
      `${process.env.REACT_APP_IBL_DM_URL}/api/catalog/pathways/?${params}`,
      {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Token ' + localStorage.getItem('dm_token'),
        },
      }
    )
      .then((response) => {
        if (response.ok) {
          setShowDeletePopUp(false);
          setRefresher(Date.now());
          handleSetNotification(true, 'Pathway deleted successfully!');
        } else {
          console.error('Failed to delete pathway');
          setShowDeletePopUp(false);
          handleSetNotification(false, 'Error deleting the pathway');
        }
      })
      .catch((error) => {
        console.error('Error deleting pathway:', error);
        setShowDeletePopUp(false);
        handleSetNotification(false, 'Error deleting the pathway');
      });
    setSelectedPathway(null);
  };

  return (
    <>
      <div className="div-block-183">
        <div className="div-block-205">
          <div className="div-block-206"></div>
          <div className="text-block-113">AUTHORING | PATHWAYS</div>
        </div>
        <div className="div-block-308">
          <a
            prop-events-value-onclick="handleAddNewCourseClick"
            prop-events-names="onClick"
            href="#"
            onClick={() => setAddOrEditPathwayFocused(true)}
            className="link-block-22 w-inline-block"
          >
            <div className="div-block-207 first active follow-user">
              <div className="text-block-111">Add New Pathway</div>
            </div>
          </a>
        </div>
      </div>
      <div react-component="CourseTable" className="table_cont-2">
        <div className="div-block-217">
          {/*<div className="div-block-169">
            <div>
              <div
                prop-data-value-tablename="Programs"
                prop-data-names="tableName"
                className="text-block-135"
              >
                Programs
                <br />
              </div>
            </div>
          </div>*/}
          <div className="div-block-169">
            {/*<div className="div-block-171">
              <div className="sm">Show</div>
              <div className="form-block w-form">
                <TableSizeDropdown setSize={setSize} />
                <div className="w-form-done">
                  <div>Thank you! Your submission has been received!</div>
                </div>
                <div className="w-form-fail">
                  <div>
                    Oops! Something went wrong while submitting the form.
                  </div>
                </div>
              </div>
              <div className="sm">entries</div>
            </div>*/}
            <div className="div-block-171">
              <div className="sm">Search:</div>
              <div className="form-block w-form">
                <form
                  id="email-form-2"
                  name="email-form-2"
                  data-name="Email Form 2"
                  method="get"
                  data-wf-page-id="65830fc855f7d3a66ce3da0b"
                  data-wf-element-id="718b5728-a03b-be9a-4e5e-ebcb03ab51be"
                >
                  <input
                    onChange={(e) => setSearch(e?.target?.value)}
                    className="input w-input"
                    maxLength="256"
                    name="field-3"
                    data-name="Field 3"
                    placeholder=""
                    prop-events-value-onchange="handleSearchBarOnChange"
                    type="text"
                    id="field-3"
                    prop-events-names="onChange"
                    required=""
                  />
                </form>
                <div className="w-form-done">
                  <div>Thank you! Your submission has been received!</div>
                </div>
                <div className="w-form-fail">
                  <div>
                    Oops! Something went wrong while submitting the form.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div react-component="table" className="table">
            <div className="th">
              <div className="tc tcell _5">
                <div className="sm">#</div>
              </div>
              <div className="tc tcell _25">
                <div className="w_sort">
                  <div className="sm">Name</div>
                </div>
              </div>
              <div className="tc tcell _10">
                <div className="w_sort">
                  <div className="sm">Visibility</div>
                </div>
              </div>
              <div className="tc tcell _10">
                <div className="w_sort">
                  <div className="sm">Nbr of courses</div>
                </div>
              </div>
              <div className="tc tcell _10">
                <div className="w_sort">
                  <div className="sm">Total Duration</div>
                </div>
              </div>
              <div className="tc tcell w_a _10">
                <div className="sm"></div>
              </div>
            </div>
            {loading ? (
              <IBLSpinLoader
                color={'#FFF'}
                size={20}
                containerHeight={'200px'}
              />
            ) : Array.isArray(filteredPathways) &&
              filteredPathways.length > 0 ? (
              filteredPathways.map((pathway, index) => {
                const totalMinutes = (pathway?.path || []).reduce(
                  (sum, item) => {
                    const duration =
                      item?.duration ||
                      item?.edx_data?.duration ||
                      item?.data?.edx_data?.duration ||
                      '';
                    return sum + parseDurationToMinutes(duration);
                  },
                  0
                );
                const formattedDuration = formatMinutes(totalMinutes);

                const isEditButtonDisabled = pathway?.user_id !== getUserId();
                return (
                  <div
                    key={index}
                    react-component="AuthoringProgramsRow"
                    className="tr"
                  >
                    <div className="tc tcell _5">
                      <div prop-rowindex="" className="m">
                        {index + 1}
                      </div>
                    </div>
                    <div
                      onClick={() => {
                        setFocusedPathwayForDisplay(pathway);
                      }}
                      className="tc tcell _25"
                    >
                      <img
                        className="r-i"
                        src={getRamdomCourseImg()}
                        alt={pathway?.name}
                      />
                      <a
                        href={'#'}
                        onClick={(e) => e.preventDefault()}
                        //to={`/studio/authoring/programs/${pathway?.data?.program_id}`}
                        className="tl-2 np"
                      >
                        <span prop-coursetitle="" className="nb">
                          {pathway?.name}
                        </span>
                      </a>
                    </div>
                    <div className="tc tcell _10">
                      <div prop-courseid="" className="sm">
                        {pathway?.visible ? 'Public' : 'Private'}
                      </div>
                    </div>
                    <div className="tc tcell _10">
                      <div prop-programslug="" className="sm">
                        {Array.isArray(pathway?.path)
                          ? pathway?.path.length
                          : 0}
                      </div>
                    </div>

                    <div className="tc tcell _10">
                      <div className="sm">{formattedDuration}</div>
                    </div>

                    <div className="tc tcell w_a _10">
                      <div
                        onClick={() => {
                          setFocusedPathwayForEdit(pathway);
                          setAssignContentPopupOpen(true);
                        }}
                        className="div-block-207 first active follow-user redeem-btn mg-l16 edit-pathway-btn alt-btn"
                      >
                        <div className="text-block-111 red-text cf">Assign</div>
                      </div>
                      <div
                        onClick={
                          isEditButtonDisabled
                            ? undefined
                            : () => {
                                setFocusedPathwayForEdit(pathway);
                                setAddOrEditPathwayFocused(true);
                              }
                        }
                        className="div-block-207 first active follow-user redeem-btn mg-l16 edit-pathway-btn"
                        style={{
                          cursor: isEditButtonDisabled
                            ? 'not-allowed'
                            : 'pointer',
                          opacity: isEditButtonDisabled ? 0.5 : 1,
                        }}
                      >
                        <div className="text-block-111 red-text cf">Edit</div>
                      </div>
                      <div
                        onClick={() => {
                          setSelectedPathway(pathway);
                          setShowDeletePopUp(!showDeletePopUp);
                        }}
                        className="div-block-207 first active follow-user alt-btn delete-pathway-btn"
                      >
                        <div className="text-block-111 red-text cf">Delete</div>
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              !loading &&
              filteredPathways.length === 0 && <EmptyTableDataInfographic />
            )}
            {/*<div react-component="AuthoringProgramsPagination" className="tf">
                            <div className="div-block-289">
                                <div prop-totalitems="" prop-currentpage="" prop-itemsperpage=""
                                     className="info-3">Showing 1 to 10 of 20 entries
                                </div>
                                <div className="pagination">
                                    <div prop-currentpage="" className="arrow-invite-previous-disabled p-item">
                                        <div className="text-block fa_icon fa-arrow disabled"></div>
                                    </div>
                                    <div prop-currentpage="" className="p-active p-item">
                                        <div>1</div>
                                    </div>
                                    <div prop-currentpage="" className="p-item">
                                        <div>2</div>
                                    </div>
                                    <div prop-totalitems="" prop-currentpage="" className="p-item arrow-next">
                                        <div className="text-block fa_icon fa-arrow"></div>
                                    </div>
                                </div>
                            </div>
                        </div>*/}
          </div>
        </div>
      </div>
      {addOrEditPathwayFocused && (
        <AddPathway
          setEditData={setFocusedPathwayForEdit}
          editData={focusedPathwayForEdit}
          setFocused={setAddOrEditPathwayFocused}
          setRefresher={setRefresher}
        />
      )}
      {focusedPathwayForDisplay && (
        <PathwayDetailPopup
          pathway={focusedPathwayForDisplay}
          setFocused={setFocusedPathwayForDisplay}
        />
      )}
      {assignContentPopupOpen && (
        <AssignContentToUser
          contentType={'pathway'}
          setFocused={setAssignContentPopupOpen}
          contentData={{
            pathway_uuid: focusedPathwayForEdit?.pathway_uuid,
            display_name: focusedPathwayForEdit?.name,
          }}
          setRefresher={setRefresher}
        />
      )}
      {showDeletePopUp && (
        <DeletePopup
          message={MESSAGE?.DELETE_MESSAGE}
          warning={WARNING?.PATHWAY_WARNING}
          contentName={selectedPathway?.name}
          contentType={CONTENT_TYPE?.PATHWAY}
          confirmText={CONFIRM_TEXT?.DELETE}
          cancelText={CANCEL_TEXT?.CANCEL}
          popupType={POPUP_TYPE.ACTION}
          onConfirm={handleDeletePathway}
          onCancel={() => {
            setShowDeletePopUp(!showDeletePopUp);
          }}
          deleteable={
            (selectedPathway?.deleteable &&
              loggedInUserId == selectedPathway.user_id) ||
            false
          }
        />
      )}
    </>
  );
};

export default StudioAuthoringPathwaysViewContent;
